import { Modal, Popover } from 'bootstrap'
import { domReady } from '@/utils/dom-ready'

domReady(() => {
  const form = document.getElementById('petition_form')
  if (form) {
    const displayEditConfirmation = form.dataset.displayEditConfirmation

    // If there are input fields with popovers, show the first one on page load.
    // The popovers will have already been initialized in popovers.js, so we're not
    // checking for rel=popover or creating any popovers, just opening one if it exists.
    const firstField = document.querySelector('#petition_form input[type=text]:enabled')
    if (firstField) {
      const popover = Popover.getInstance(firstField)
      if (popover) {
        popover.show()
      }
    }

    if (displayEditConfirmation === 'true') {
      document.querySelector('#petition-save-button .submit-button').addEventListener('click', (e) => {
        document.querySelectorAll('.edit-confirmation-modal').forEach((el) => {
          Modal.getOrCreateInstance(el).show()
        })
        e.preventDefault()
      })
    }

    const editConfirmationSaveButton = document.getElementById('edit-confirmation-save')
    if (editConfirmationSaveButton) {
      editConfirmationSaveButton.addEventListener('click', (e) => {
        e.preventDefault()

        // Extract the message
        const element = document.getElementById('modal_edit_moderation_message')
        const message = element.value

        // Remove errors, if any exist.
        element.classList.remove('is-invalid')

        let errorElement = document.querySelector('.edit-confirmation-modal span.help-inline')
        if (errorElement) {
          errorElement.remove()
        }

        if (message.length > 0) {
          // set hidden field for form submission.
          document.getElementById('petition_edit_moderation_message').value = message
          form.submit()
        } else {
          element.classList.add('is-invalid')
          errorElement = document.createElement('span')
          errorElement.className = 'help-inline'
          errorElement.textContent = 'can\'t be blank'
          const inputLabel = document.querySelector(`label[for=${element.id}]`)
          inputLabel.after(errorElement)
        }
      })
    }
  }
})
